import { useForm } from 'react-hook-form';
import { Alert, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import ModalForm from '@components/common/hooks/useFormModal/ModalForm';
import RadioButtonGroup from '@components/common/HookFormMui/RadioButtonGroup';
import { plural, stringsToOptions } from '@lib/utils';
import { useMemo } from 'react';

const SessionCancelModal = ({
  onSubmit,
  submitRef,
  defaultValues = {},
  sessionId,
  hasCompleted,
  query,
}) => {

  const form = useForm({
    mode: 'onSubmit',
    defaultValues,
  });

  const { data: participants } = query ?? {};

  const alertText = useMemo(() => {
    // Has any participant data been recorded for the session?
    const attendees = participants?.filter(p => p.participantAttendance.find(a => a.session_id === sessionId && a.status === 'PRESENT'));
    const attendeeCount = attendees?.length || 0;
    const hasAttendees = attendeeCount > 0;

    let alertText = '';
    if (hasCompleted && !hasAttendees) {
      alertText = 'This session has “Complete Session” data entered. If you click the Cancel Session button below the data will be deleted and your session will be canceled.';
    } else if (!hasCompleted && hasAttendees) {
      alertText = `This session has ${plural({ noun: 'attendee', count: attendeeCount })}. If you click the Cancel Session button below, session attendance will be reset to zero and your session will be canceled.`;
    } else if (hasCompleted && hasAttendees) {
      alertText = `This session has ${plural({ noun: 'attendee', count: attendeeCount })} and “Complete Session” data entered. If you click the Cancel Session button below, the data will be deleted, session attendance will be reset to zero, and your session will be canceled.`;
    }
    return alertText;
  }, [participants]);

  return (
    <ModalForm
      form={form}
      onSubmit={onSubmit}
      submitRef={submitRef}
    >
      <Grid container spacing={1}>
        <Grid xs={12}>
          <Typography variant="h3" color="#000">
            Why is this session canceled?
          </Typography>
        </Grid>
        {alertText && (
          <Grid xs={12}>
            <Alert severity="warning">
              {alertText}
            </Alert>
          </Grid>
        )}
        <Grid xs={12} sm={10}>
          <RadioButtonGroup
            key="key-cancel_reasons"
            id="field-cancel_reason"
            name="cancel_reason"
            formLabelProps={{
              component: 'h2',
              style: {
                marginTop: 0,
                fontSize: '20px',
              }
            }}
            placeholder={'Select reason'}
            control={form.control}
            fullWidth
            required
            otherTextField
            otherTextFieldLabel={'If Other, please describe reason below*'}
            options={stringsToOptions([
              'No participants showed up',
              'Partner requested to cancel',
              'Staffing emergency',
              'Created by mistake',
              'Other',
            ])}
          />
        </Grid>
      </Grid>
    </ModalForm>
  );
};

export default SessionCancelModal;
